import React, { useState } from 'react';
import { UserPlusIcon } from '@heroicons/react/20/solid';
import vCardFactory from 'vcards-js';
import { LINK_TYPE } from '../../../../utils/constants';

const profileDownloader = ({ textColor, user, optimizedAvatar, links }) => {
  // Base64 vorbereiten
  const [base64String, setBase64String] = useState('');

  const generateBase64String = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(optimizedAvatar);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result.split(',')[1];
          setBase64String(base64Data);
          resolve(base64Data);
        };
        reader.onerror = (error) => {
          console.error('Error reading file:', error);
          reject(error);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Error converting image:', error);
        reject(error);
      }
    });
  };

  // Download TXT File
  const downloadTxtFile = (vcfText) => {
    const element = document.createElement('a');
    const file = new Blob([vcfText], { type: 'text/vcard;charset=utf-8' });
    element.href = URL.createObjectURL(file);
    element.download = 'vCard.vcf';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  // VCard erstellen
  const CreateVCard = async () => {
    // Base64 Bild erstellen, wenn noch nicht vorhanden
    let base64Image = base64String;
    if (!base64Image) {
      base64Image = await generateBase64String();
    }

    //create a new vCard
    const vCard = vCardFactory();

    //set properties
    // zuerst User Properties
    vCard.firstName = user.firstName;
    vCard.lastName = user.lastName;
    vCard.title = user.title;
    vCard.organization = user.company;
    vCard.photo.embedFromString(base64Image);
    // Link Inhalte

    links.forEach((item) => {
      switch (item.type) {
        case LINK_TYPE.ADRESSE_FIRMA:
          vCard.workAddress.label = 'Work Address';
          vCard.workAddress.street = item.strasse;
          vCard.workAddress.city = item.ort;
          vCard.workAddress.postalCode = item.plz;
          break;
        case LINK_TYPE.ADRESSE_PRIVAT:
          vCard.homeAddress.label = 'Home Address';
          vCard.homeAddress.street = item.strasse;
          vCard.homeAddress.city = item.ort;
          vCard.homeAddress.postalCode = item.plz;
          break;
        case LINK_TYPE.EMAIL_ARBEIT:
          if (!vCard.workEmail) vCard.workEmail = [];
          vCard.workEmail.push(item.email);
          break;
        case LINK_TYPE.EMAIL_PRIVAT:
          if (!vCard.email) vCard.email = [];
          vCard.email.push(item.email);
          break;
        case LINK_TYPE.TELEFON_ARBEIT:
          if (!vCard.workPhone) vCard.workPhone = [];
          vCard.workPhone.push(item.telefonnummer);
          break;
        case LINK_TYPE.TELEFON_PRIVAT:
          if (!vCard.cellPhone) vCard.cellPhone = [];
          vCard.cellPhone.push(item.telefonnummer);
          break;
        case LINK_TYPE.SOCIAL_MEDIA:
          if (!vCard.socialUrls) vCard.socialUrls = {};
          vCard.socialUrls[item.netzwerk] = 'https://' + item.link;
          break;
        case LINK_TYPE.GEBURTSTAG:
          vCard.birthday = new Date(item.geburtstag);
          break;
        case LINK_TYPE.NOTIZEN:
          if (!vCard.note) vCard.note = '';
          vCard.note += item.title + ': ' + item.link + '\n';
          break;
        case LINK_TYPE.LINK:
          if (!vCard.note) vCard.note = '';
          vCard.note += item.title + ': ' + item.link + '\n';
          break;
        default:
          break;
      }
    });

    // Fix für iOS Social Media Links: Zeigt nur CHARSET=UTF-8 an.
    let vCardString = vCard.getFormattedString();
    vCardString = vCardString.replace(
      /SOCIALPROFILE;CHARSET=UTF-8;/gm,
      'SOCIALPROFILE;'
    );
    // console.log(vCardString);
    return vCardString;
    // return vCard.getFormattedString();
  };

  return (
    <button
      type="button"
      className="inline-flex items-center gap-x-2 rounded-md bg-white px-3.5 py-2.5 text-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 shadow-lg hover:shadow-sm transition-all"
      style={{ color: textColor }}
      onClick={async () => {
        const vcfText = await CreateVCard();
        downloadTxtFile(vcfText);
      }}
    >
      Kontakt hinzufügen
      <UserPlusIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
    </button>
  );
};

export default profileDownloader;
